import { Box } from "@mui/material";
import { useEffect } from "react";
import ChangeOrderModal from "../../components/ChangeOrderModal";

export const AddToMrqTable = ({
  plant,
  data,
  mrqDetails,
  mrqMaterials,
  setMrqMaterials,
}) => {
  useEffect(() => {
    console.log("dataaaaa", data);
    const materials = data
      .map((row) => {
        return {
          ...row.right,
        };
      })
      .filter(Boolean);

    setMrqMaterials(materials);
  }, [data, setMrqMaterials]);

  const consolidatedMaterials = [];

  const onChangeDetails = () => {};

  return (
    <Box>
      <ChangeOrderModal
        plant={plant}
        mrqDetails={mrqDetails}
        drawing={{}}
        consolidatedMaterials={consolidatedMaterials}
        mrqMaterials={mrqMaterials}
        setMrqMaterials={setMrqMaterials}
        type="add"
      />
    </Box>
  );
};
